import { useBlockActionStore } from '@editorStores'
import { CHECK_SETTINGS_SECTION_KEYS, checkSettingsBlockAction } from '../constants'

/**
 * True while any check settings tab has unsaved edits. Derives directly from
 * `CHECK_SETTINGS_SECTION_KEYS`, so a new section is covered automatically as
 * soon as it's added there — nothing here needs to change.
 *
 * Narrowed to a boolean (rather than subscribing to the whole `blockedActions`
 * Set) so this only re-renders when crossing the blocked/unblocked boundary,
 * matching the convention in useBlockAction/useIsAnyActionBlocked.
 */
const useIsAnyCheckSettingsSectionBlocked = (): boolean =>
  useBlockActionStore(state =>
    CHECK_SETTINGS_SECTION_KEYS.some(key =>
      state.blockedActions.has(checkSettingsBlockAction(key)),
    ),
  )

export default useIsAnyCheckSettingsSectionBlocked
